import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

const guideArticles = [
  { title: 'OOPBUY Spreadsheet Einrichtung', slug: '/oopbuy-spreadsheet-einrichtung', readTime: '6 Min.', desc: 'Schritt für Schritt Anleitung für die erste Einrichtung deines OOPBUY Spreadsheets.' },
  { title: 'OOPBUY QC Guide', slug: '/oopbuy-qc-guide', readTime: '8 Min.', desc: 'Alles über die Qualitätskontrolle deiner Bestellungen aus China.' },
  { title: 'Versand nach Deutschland', slug: '/oopbuy-versand-deutschland', readTime: '7 Min.', desc: 'Versandmethoden, Kosten und Lieferzeiten im Vergleich.' },
  { title: 'Agent Vergleich 2025', slug: '/oopbuy-agent-vergleich', readTime: '9 Min.', desc: 'So findest du den besten Agenten für deine Bestellungen.' },
  { title: 'Taobao Einkaufsguide', slug: '/oopbuy-taobao-guide', readTime: '7 Min.', desc: 'Taobao richtig nutzen — von der Suche bis zum Kauf.' },
  { title: 'Weidian Guide', slug: '/oopbuy-weidian-guide', readTime: '6 Min.', desc: 'Versteckte Schätze auf Weidian finden und bestellen.' },
  { title: 'Yupoo Integration', slug: '/oopbuy-yupoo-guide', readTime: '5 Min.', desc: 'Yupoo-Fotoalben clever in deinen Workflow einbinden.' },
  { title: 'Kosten sparen mit OOPBUY', slug: '/oopbuy-kosten-sparen', readTime: '7 Min.', desc: '10 bewährte Strategien, um bei jeder Bestellung zu sparen.' },
  { title: 'Batch-Bestellungen', slug: '/oopbuy-batch-bestellungen', readTime: '8 Min.', desc: 'Große Mengen clever managen — für Reseller und Power-Shopper.' },
];

export default function Einkaufsfuehrer() {
  return (
    <>
      <Navbar />
      <main>
        <section className="relative w-full h-[380px] md:h-[480px] overflow-hidden mt-16">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Organized%20desk%20workspace%20with%20multiple%20fashion%20catalogs%20open%20notebook%20with%20handwritten%20notes%20tablet%20displaying%20ecommerce%20interface%20and%20a%20cup%20of%20tea%20warm%20morning%20light%20streaming%20through%20large%20window%20editorial%20lifestyle%20photography%20cozy%20productive%20atmosphere%20german%20aesthetic&width=1800&height=960&seq=einkaufsfuehrer-hero&orientation=landscape"
              alt="OOPBUY Einkaufsführer"
              title="OOPBUY Spreadsheet Einkaufsführer Deutschland"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          <div className="relative z-10 h-full flex flex-col justify-center px-4 md:px-6 max-w-[1280px] mx-auto w-full">
            <p className="text-white/70 text-xs md:text-sm mb-3 font-label tracking-wider uppercase">Dein Einkaufsführer</p>
            <h1 className="font-heading text-3xl md:text-6xl font-bold text-white leading-tight max-w-3xl">
              OOPBUY Spreadsheet<br />Einkaufsführer
            </h1>
            <p className="text-white/70 text-sm md:text-lg mt-4 max-w-xl">
              Alle Guides, Tipps und Anleitungen für deinen erfolgreichen Einkauf auf Taobao, Weidian und Yupoo.
            </p>
          </div>
        </section>

        <section className="bg-background-50 py-14 md:py-20">
          <div className="max-w-[1000px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {guideArticles.map((article) => (
                <a
                  key={article.slug}
                  href={article.slug}
                  className="group block bg-background-100 rounded-lg p-5 md:p-6 hover:bg-background-200/70 transition-colors cursor-pointer"
                >
                  <span className="text-xs text-accent-600 bg-accent-100/80 px-2 py-0.5 rounded-full font-label mb-3 inline-block">
                    {article.readTime}
                  </span>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {article.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 mt-3 text-xs text-primary-600 font-medium">
                    Zum Artikel
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </a>
              ))}
            </div>

            <div className="mt-12 text-center">
              <a
                href="/"
                className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i>
                Zurück zur Startseite
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: 'OOPBUY Spreadsheet Einkaufsführer',
            description: 'Alle Guides, Tipps und Anleitungen für deinen erfolgreichen Einkauf auf Taobao, Weidian und Yupoo mit dem OOPBUY Spreadsheet.',
            url: 'https://oopbuyspread.rest/einkaufsfuehrer',
            hasPart: guideArticles.map((a) => ({
              '@type': 'Article',
              name: a.title,
              url: `https://oopbuyspread.rest${a.slug}`,
              description: a.desc,
            })),
          }),
        }}
      />
    </>
  );
}